import { useState } from "react";
import { Link } from "react-router-dom";
import { Box, Text } from "@chakra-ui/react";

import Font from "../Utils/Calligraphy";
import Colors from "../Utils/Colors";

export const CreditsBox = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      marginBottom="2rem"
    >
      <Text
        fontFamily={Font.Bold}
        fontSize={22}
        decoration={"underline"}
        color={isHovered ? Colors.Magenta : "inherit"}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Link to="/credits">Credits</Link>
      </Text>
    </Box>
  );
};
